module.exports = __webpack_public_path__ + "static/media/our_partners.f903af08.png";